<template>

    <v-dialog

            v-model="value"
            max-width="500"


    >
        <v-card  style="position:relative;" id="configureDNS_dialog">

            <v-card-title class="headline"> <span v-html="$t('dnsConfigureDialog.title')"></span>
            </v-card-title>

            <v-card-text v-if="user.haveSubscription" style="font-size:16px;">

                             <v-alert
                                     color="blue-grey"
                                     dark
                                     dense

                                     small
                                     text
                                     icon="mdi-school"

                             >
                                   <v-row align="center">
        <small>  <span v-html="$t('dnsConfigureDialog.settingUpForTheFirstTime')"></span> </small>
                                       <router-link :to="'article/how-to-access-stadia-from-unsupported-country-on-chrome-cast-ultra'" target="_blank" style="text-decoration: none;" >
                                    <v-btn color="blue-grey " class="first-time-read-how" dark small dense outlined> <span v-html="$t('account.readHow')"></span></v-btn>
                                       </router-link>
                                   </v-row>

    </v-alert>
                   <span v-show="false"><br> <span v-html="$t('dnsConfigureDialog.subtitle')"></span>
                        </span>

                <div v-show="!connected" style="position: relative">
                    <br>
                    <v-text-field
                            class="centered-input"
                            color="success"
                            v-model="networkIP"
                            label="IP address"
                            disabled
                            style="margin-top:20px;    margin-right: 40px;"
                            text-center
                    >Input</v-text-field>
                    <v-tooltip top small >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                            small
                                            v-bind="attrs"
                                            v-on="on"
                                            style="position: absolute; top: 60px; right: 10px;"
                                    >
                                      mdi-information
                                    </v-icon>
                                  </template>
                                  <span>The IP address of the network you are currently connect to</span>
                                </v-tooltip>


                <server-selection :insideModal="true" class="server-selection" style="position:relative;top:-20px;" :connected="connected"
                                  :connectedTo="connectedTo" :disabled="connected || connecting"
                                  v-model="selectedServer"></server-selection>
                <v-btn
                        v-if="!connecting"
                        color="pink darken-1"
                        outlined
                        block
                        large
                        @click="onSubmit"
                        style="margin-top:40px;"
                >
                    <span>Link this network</span>
                </v-btn>
                    <div v-if="connecting" style="font-size: 13px;margin-bottom:4px;height:80px;    top: 13px;position:relative;">
                        Please wait while we detect the best server for you<br>
                        Do not close the window until the process completes.<br>
                        This process may take <b>up to 60 seconds</b>.
                        <v-progress-linear color="pink"
                                           style="margin-top:10px"
                                           :value="autoDetectServerProgress"></v-progress-linear>
                    </div>
             </div>
                <span v-if="connected">

                    <v-card
                            style="margin-top:25px;"
                            outlined
                    >
                        <v-card-title><v-icon style="margin-right:5px;">mdi-link-variant</v-icon>Linked network</v-card-title>
                        <v-card-text>
                            IP: <br><div style="font-size:18px;color:#000000de">{{dnsConfiguration.ip}} </div><br>
                            <span v-html="$t('dnsConfigureDialog.serverLocation')"></span>:<br> <div style="font-size:18px;color:#000000de">    <span  :class="'flag-icon flag-icon-' + dnsConfigurationServer.icon" style="margin: 0px 7px 0 0; border-radius: 2px; width: 21px; height: 16px; box-shadow: 0px 0px 5px 0px rgb(0 0 0 / 39%);"></span> {{dnsConfigurationServer.name}}</div><br>
                            <!--isCurrentNetwork: <br>{{dnsConfigurationIsCurrentNetwork}}<br>-->
                            <span v-html="$t('dnsConfigureDialog.status')"></span>: <br><div style="font-size:18px;color:#000000de">{{dnsConfigurationStatus}}
                              <v-tooltip top small v-if="this.dnsConfigurationIsProcessing">
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                            small
                                            v-bind="attrs"
                                            v-on="on"
                                    >
                                      mdi-information
                                    </v-icon>
                                  </template>
                                 <span v-html="$t('dnsConfigureDialog.processingTooltip')"></span>
                                </v-tooltip>

                        </div>
                            <v-progress-linear color="pink" v-if="this.dnsConfigurationIsProcessing"
                                               style="width:250px;margin-top:10px"
                                               :value="processingProgress"></v-progress-linear>
                        </v-card-text>
                        <v-card-actions class="unlink-container">
                               <v-spacer></v-spacer>
                            <v-btn text color="pink" @click="unlinkNetwork">
                                <span v-html="$t('dnsConfigureDialog.unlink')"></span>
                            </v-btn>
                        </v-card-actions>

                    </v-card>

                </span>
            </v-card-text>
            <v-card-text v-if="!user.haveSubscription" style="margin-top:25px;">
                <v-alert
                        color="blue-grey"
                        dark
                        dense

                        small
                        text
                        icon="mdi-information-outline"

                >
                    <v-row align="center">
                        <div> <span v-html="$t('dnsConfigureDialog.subscriptionRequiredTitle')"></span></div>
                        <small> <span v-html="$t('dnsConfigureDialog.subscriptionRequiredSubtitle')"></span>  </small>
                    </v-row>

                </v-alert>
            </v-card-text>
            <v-card-actions>
                <v-btn
                        color="red darken-1"
                        text
                        @click="close"
                >
                    <span><span v-html="$t('dnsConfigureDialog.close')"></span></span>
                </v-btn>
                <v-spacer></v-spacer>


            </v-card-actions>
        </v-card>
    </v-dialog>

</template>

<style scoped>

    .first-time-read-how {
        margin-top: -14px;right: 9px; position: absolute;
    }

    .rtl .first-time-read-how {
        right: auto;
        left: 9px;
    }

    .unlink-container{
        position: absolute;right:0;bottom:0;
    }

    .rtl .unlink-container{
        right:auto;
        left:0;
    }

    .centered-input >>> input {
        text-align: center;
        font-size: 24px;
        letter-spacing: 3px;

    }



    >>> .v-dialog { width: 500px; margin: 0px; max-height: 100%;  }
    >>> .v-dialog__content { height: 454px;
        position: fixed;
        top: 0;
        bottom: 0;
        margin: auto;
        overflow: hidden; }

</style>


<style>


</style>

<script>

    import config from '../config'
    import {mapState} from 'vuex'
    import serverSelection from '../views/extension/components/serverSelection'
    import RegionFinder from '../external/regionFinder'

    export default {
        name: 'Modal_extensionNotControllable',
        props: ['value'],
        data: () => ({
            selectedServer: 'AutoDetect',
            connected: false,
            connecting: false,
            connectedTo: '',
            networkIP: '',
            dnsConfiguration: {serverCode: '', ip: '', createdDate: ''},
            dateNowItervalId: -1,
            dateNow: 0,
            autoDetectStartTime: 0,
            serverList: []

        }),
        async created() {

            this.serverList = this.serverList.concat(await (await fetch(`${config.serverURL}/region/listUI`)).json())

            const response = await fetch(`${config.serverURL}/account/getDnsConfiguration`, {
                method: 'POST',
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify({
                    userToken: localStorage.signInToken,
                })
            });

            const dnsConfiguration = await response.json();
            if (!dnsConfiguration.error) {

                this.connected = true;
                this.dnsConfiguration = dnsConfiguration;
                this.connectedTo = dnsConfiguration.serverCode;

            }

            this.networkIP = (await (await fetch(`${config.serverURL}/account/ip`)).json()).ip

            this.dateNowItervalId = setInterval(() => this.dateNow = Date.now(), 1000);

        },
        destroyed() {
            clearInterval(this.dateNowItervalId);
        },
        computed: {
            ...mapState(['user']),
            dnsConfigurationIsProcessing() {

                return this.dnsConfiguration.createdDate > (this.dateNow - (5 * 60 * 1000));

            }, dnsConfigurationStatus() {

                return this.dnsConfigurationIsProcessing ? 'processing' : 'active';

            }, dnsConfigurationServer() {

                return this.serverList.find(i=>i.code === this.dnsConfiguration.serverCode);

            },
            processingProgress() {

                const FiveMinutes = 5 * 60 * 1000;
                const completed = this.dateNow - this.dnsConfiguration.createdDate;

                return completed / FiveMinutes * 100;
            },
            autoDetectServerProgress() {

                const OneMinute = 1 * 60 * 1000;
                const completed = this.dateNow - this.autoDetectStartTime;

                return completed / OneMinute * 100;
            },
            dnsConfigurationIsCurrentNetwork() {

                return this.networkIP === this.dnsConfiguration.ip;

            }
        },
        methods: {
            close() {
                this.$emit('input', false);
            },
            async onSubmit() {
debugger;
                if(this.selectedServer === 'AutoDetect'){

                    this.connecting = true;
                    this.autoDetectStartTime = Date.now();

                    this.selectedServer = await this.autoDetectFastestServer();

                }

                const response = await fetch(`${config.serverURL}/account/dnsConfiguration`, {
                    method: 'POST',
                    headers: {"Content-Type": "application/json"},
                    body: JSON.stringify({
                        userToken: localStorage.signInToken,
                        serverCode: this.selectedServer
                    })
                });

                this.dnsConfiguration = await response.json();
                this.connected = true;
            },
            unlinkNetwork() {
                this.connected = false;
                this.connecting = false;
                this.dnsConfiguration = {};
                fetch(`${config.serverURL}/account/dnsConfigurationUnlink`, {
                    method: 'POST',
                    headers: {"Content-Type": "application/json"},
                    body: JSON.stringify({
                        userToken: localStorage.signInToken
                    })
                });

            },
            async autoDetectFastestServer(){

              return (await (new RegionFinder()).getFastest(true, 'AutoDetect')).name;

            }
        },
        components: {

            serverSelection

        }


    };
</script>
